import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AuthService } from '../app-service/auth.service';
@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private router:Router,private authService:AuthService,) { }
  intercept(req:any, next:any){
    if(req.headers.get('No-Auth')=="True")
    {
      return next.handle(req.clone());
    }
    
    if(this.authService.getToken())
         {
             const clonedreq=req.clone({
                headers:req.headers.set("Authorization","Bearer " + localStorage.getItem('userToken'))
           });

             return next.handle(clonedreq)
             .pipe(
              tap(
                event =>{ },
                error => {
                if(error.status=== 401)

                           this.router.navigateByUrl('/');
                }
              )
            );
         }
        else{
          this.router.navigateByUrl('/')
        }
  }
}




